import React from 'react';
import { connect } from 'react-redux';
import { css, useTheme } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';
import BirdiLogoSVG from '@birdi/icons/birdi-logo-navy.svg';
import InboxIcon from '@birdi/icons/mail.svg';
import HandSVG from '@birdi/icons/hand.svg';
import { ProgressBar } from './progress-bar';
import * as styles from './styles';
import { AuthState } from '../reducer';
import { Link } from 'react-router';

interface VerifyYourEmailProps {
  auth: AuthState;
}

const VerifyYourEmail: React.FC<VerifyYourEmailProps> = (props) => {
  const theme = useTheme() as BirdiTheme;

  return (
    <>
      {/* Logo - Fixed at top */}
      <div css={styles.logoContainer}>
        <BirdiLogoSVG />
      </div>

      {/* Scrollable Content */}
      <div css={styles.scrollableContent}>
        {/* Header Section */}
        <div css={styles.headerSection}>
          <div css={styles.iconContainer}>
            <div css={styles.iconWrapper(theme)}>
              <InboxIcon />
            </div>
            <h1 css={styles.title}>Verify your email</h1>
          </div>

          <ProgressBar currentStep={2} totalSteps={6} />

          <p css={styles.subtitle}>
            <span
              css={css`
                font-size: 1.25rem;
                margin-right: 0.5rem;
              `}
            >
              👋
            </span>
            Welcome {props.auth.fname}!
          </p>
        </div>

        {/* Content */}
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 1rem;
          `}
        >
          <p
            css={css`
              margin: 0 0 1rem 0;
            `}
          >
            We've sent a verification link to:
            <br />
            <span
              css={css`
                font-weight: 600;
              `}
            >
              {props.auth.email}
            </span>
          </p>
          <p
            css={css`
              margin: 0;
            `}
          >
            Just click the link in your inbox to confirm your email address.
          </p>

          <div
            css={(theme: BirdiTheme) => css`
              margin-top: 1rem;
              font-size: 0.85rem;
              color: ${theme.mono60};
            `}
          >
            <p
              css={css`
                margin: 0;
              `}
            >
              Didn't get the email? Check your spam folder or{' '}
              <Link
                to="/resend-verification"
                css={(theme: BirdiTheme) => css`
                  color: ${theme.deepOcean};
                  text-decoration: underline;
                  font-weight: 500;

                  &:hover {
                    text-decoration: none;
                  }
                `}
              >
                resend email
              </Link>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Fixed Footer - Help Link */}
      <div css={styles.fixedFooter}>
        <div css={styles.helpLink}>
          Need help? <a href="mailto:support@birdi.io">Contact support</a>
        </div>
      </div>
    </>
  );
};

export default connect((state: any) => ({ auth: state.auth }))(VerifyYourEmail);
